function updatecart(line, quantity, clickedItem, event) {
    return;
    event.preventDefault();
    document.querySelector(".cart-drawer").classList.add("is-loading");
    console.log(line, quantity);
    if (parseInt(quantity) == 0) {
        clickedItem.closest(".cart__item").classList.add("is-animated");
        clickedItem.closest(".cart__item").classList.add("is-removed");
    }

    let addData = {
        line: parseInt(line),
        quantity: parseInt(quantity)
    };

    jQuery.post('/cart/change.js', addData).done(function (cart) {
        featchcart(false);
    }).fail(function () {
        document.querySelector(".cart-drawer").classList.remove("is-loading");
    })
}


function changeinput(line, input, event) {
    return;
    var qty = input.value;
    updatecart(line, qty, input, event);
}



function featchcart(opencart) {
    fetch('/').then(function (response) {
        // The API call was successful!
        return response.text();
    }).then(function (html) {
        // Convert the HTML string into a document object
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        document.querySelector('#cart-drawer').innerHTML = doc.querySelector("#cart-drawer").innerHTML;
        document.querySelector(".header__cart__status__holder").innerHTML = doc.querySelector(".header__cart__status__holder").innerHTML
        if (opencart) {
            document.querySelector("[data-cart-toggle]").click();
        }
        document.querySelector(".cart-drawer").classList.remove("is-loading");

    }).catch(function (err) {
        // There was an error
        console.warn('Something went wrong.', err);
    });
}

function changemaster() {
    var master = document.querySelectorAll("#masterselect option");

    var selected = document.querySelectorAll(".product__selectors .radio__buttons input:checked");;
    var variantname = '';

    for (let i = 0; i < selected.length; i++) {
        const element = selected[i].value;
        if (i == selected.length - 1) {
            variantname = variantname + element;
        }
        else {
            variantname = variantname + element + ' / ';
        }
    }

    var choosen = false;
    var available = false;
    var id = "";
    var price = "";
    var quantity = 0;
    for (let j = 0; j < master.length; j++) {
        const element = master[j].getAttribute("data-index");
        if (element == variantname) {
            id = master[j].getAttribute("value");
            document.querySelector("#masterselect").value = id;
            price = master[j].getAttribute("data-price");
            var choosen = true;
            available = master[j].getAttribute("data-available");
            quantity = master[j].getAttribute("data-max");
            console.log(available, price, id, quantity)
        }
    }


    if (parseInt(quantity) < 16) {
     
    var inventoryHTML = available == 'true' ? `<span class="in-stock-cust" >In stock, ready to ship</span><p class="ProductForm__Inventory Text--subdued product__block variant__countdown count-is-low" data-remaining-wrapper="" style="--block-padding-bottom: 12px"><span class="variant__countdown__low">Only <span data-remaining-max="10" data-remaining-count="">` + quantity + `</span> left!</span></p>` : ` <span class="out-stock-cust" >Out of stock</span>`;
    document.querySelector(".instock-div") ? document.querySelector(".instock-div").innerHTML = inventoryHTML : "";   
    }else{

    var inventoryHTML = available == 'true' ? `<span class="in-stock-cust" >In stock, ready to ship</span>` : ` <span class="out-stock-cust" >Out of stock</span>`;
    document.querySelector(".instock-div") ? document.querySelector(".instock-div").innerHTML = inventoryHTML : "";
    }



    var availabletext = document.querySelector("#masterselect").getAttribute("data-available-text");
    var soldouttext = document.querySelector("#masterselect").getAttribute("data-solout-text");
    var unavailabletext = document.querySelector("#masterselect").getAttribute("data-unavailable-text");

    if (choosen) {
        if (available == "true") {
            document.querySelector(".latest-add-to-cart-btn").textContent = availabletext;
            document.querySelector(".latest-add-to-cart-btn").removeAttribute("disabled");
        }
        else if (available == "false") {
            document.querySelector(".latest-add-to-cart-btn").textContent = soldouttext;
            document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled");
        }
    }
    else {
        document.querySelector(".latest-add-to-cart-btn").textContent = unavailabletext;
        document.querySelector(".latest-add-to-cart-btn").setAttribute("disabled", "disabled")
    }

}

document.querySelectorAll(".product__selectors .radio__buttons input").forEach(function (input) {
    input.addEventListener("change", function () {
        changemaster();
    })
})

changemaster();

async function addToCart(productId, quantity, button) {
    try {
        const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: productId,
                quantity: quantity,
            }),
        });

        if (!response.ok) {
            throw new Error('Error adding to cart');
        }

        const data = await response.json();




        // featchcart(true);
        window.location.href = '/cart'



        console.log('Add to Cart Response:', data); // Debug log
    } catch (error) {
        // Display error message


        console.error('Add to Cart Error:', error);
    }
}


document.querySelectorAll(".latest-add-to-cart-btn").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
        e.preventDefault();
        var id = document.querySelector("#masterselect").value
        addToCart(id, 1, btn)
    })
})

$(document).ready(function(){
  $(document).on('click','.pdp-chartvar-opt',function(e){
    e.preventDefault();
    $('body').addClass('product-modal-body');
  })
  $(document).on('click','.product-modal-body .product-modal__close',function(e){
    e.preventDefault();
    $('body').removeClass('product-modal-body');
  })
})
















